import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationEventsService {
  private readonly homeRequestedSubject = new Subject<void>();

  readonly homeRequested$ = this.homeRequestedSubject.asObservable();

  requestHome(): void {
    this.homeRequestedSubject.next();
  }
}
